import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import { PGA_COM_HOST } from 'env'

const OneTimeOnlyDialog = ({ isOpen, onClose }) => (
  <Dialog
    isOpen={isOpen}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    showCloseButton
    aria-labelledby="pga-hope-one-time-only-dialog-title"
  >
    {() => (
      <Box m={2}>
        <DialogTitle id="pga-hope-one-time-only-dialog-title">
          PGA HOPE events are one-time only
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            It looks like you have already registered for or taken part in a PGA
            HOPE event. PGA HOPE events are one-time only, so you cannot
            register again. Explore other golf lessons and events near you on
            PGA.com.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            href={`${PGA_COM_HOST}/golf-lessons`}
          >
            Find Golf Lessons Near You
          </Button>
        </DialogActions>
      </Box>
    )}
  </Dialog>
)

OneTimeOnlyDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default OneTimeOnlyDialog
